import { render } from "./HealthCertForm.vue?vue&type=template&id=1ad2f706"
import script from "./HealthCertForm.vue?vue&type=script&lang=js"
export * from "./HealthCertForm.vue?vue&type=script&lang=js"

import exportComponent from "/builds/infinitesoftsolutions/haz/haz-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__